import e from "react";
import t from "react-dom";
import { Popover as o } from "../../general/Popover/index.js";
import { suppressToggle as n } from "../../../utils/dom/toggle.js";
import { isEscKey as r } from "../../../constants/keyboard.js";
import { closest as i } from "../../../utils/dom/index.js";
import { componentName as s } from "../../../utils/bem/index.js";
function p(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function l(e, t) {
  for (var o = 0; o < t.length; o++) {
    var n = t[o];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function a(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}
function c(e) {
  return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function u(e, t) {
  return (u = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var f = function (f) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && u(e, t);
  }(b, f);
  var d,
    h,
    m,
    y = (d = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        o = c(b);
      if (d) {
        var n = c(this).constructor;
        t = Reflect.construct(o, arguments, n);
      } else t = o.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : p(this);
    });
  function b() {
    var e;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, b), e = y.apply(this, arguments), a(p(e), "state", {
      open: !1
    }), a(p(e), "_handleToggle", function (t) {
      if ((!e.props.keepOpen || !e.state.open) && (!e.props.disabled || e.state.open) && e._shouldClickCauseToggle(t)) {
        if (e.props.onToggle) {
          var o = !e.state.open;
          setTimeout(function () {
            return e.props.onToggle(o);
          }, o ? 0 : 200);
        }
        e.setState({
          open: !e.state.open
        });
      }
    }), a(p(e), "toggle", function () {
      e._handleToggle();
    }), a(p(e), "_handleGlobalKeydown", function (t) {
      r(t) && e.close();
    }), a(p(e), "_handleGlobalClick", function (t) {
      i(t.target, {
        node: e.refs.icon
      }) || (n(t), e.props.killCloseEvent && (t.preventDefault(), t.stopPropagation()), e.close());
    }), e;
  }
  return h = [{
    key: "_shouldClickCauseToggle",
    value: function value(e) {
      if (!e) return !0;
      if (this.props.ignoreClick && this.props.ignoreClick(e)) return !1;
      var o = t.findDOMNode(this.refs.popover),
        n = o && i(e.target, {
          node: o
        }),
        r = i(e.target, {
          node: this.refs.icon
        });
      return r && !n || this.state.open && r && this.props.closeOnClickInside;
    }
  }, {
    key: "close",
    value: function value() {
      this.state.open && this._handleToggle();
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      window.removeEventListener("click", this._handleGlobalClick, !0), window.removeEventListener("keydown", this._handleGlobalKeydown);
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e, t) {
      t.open !== this.state.open && (this.state.open ? (window.addEventListener("keydown", this._handleGlobalKeydown), window.addEventListener("click", this._handleGlobalClick, !0), this.props.onOpen && this.props.onOpen()) : (window.removeEventListener("keydown", this._handleGlobalKeydown), window.removeEventListener("click", this._handleGlobalClick, !0), this.props.onClose && this.props.onClose()));
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function value(e) {
      this.state.open && !this.props.disabled && e.disabled && this.setState({
        open: !1
      });
    }
  }, {
    key: "render",
    value: function value() {
      return e.createElement(this.props.nodeType, {
        title: this.props.title,
        ref: "icon",
        onClick: this._handleToggle,
        className: s("option-button", this.props.className, this.state.open && "open")
      }, this.props.label, e.createElement(o, {
        arrowPosition: this.props.arrowPosition,
        pointTo: this.props.pointTo,
        arrowOffset: this.props.arrowOffset,
        arrowDirection: this.props.arrowDirection,
        arrowSize: this.props.arrowSize,
        spaceToTarget: this.props.spaceToTarget,
        className: this.props.popoverClassName,
        edgeOffset: this.props.edgeOffset,
        open: this.state.open,
        ref: "popover"
      }, this.props.children));
    }
  }], l(b.prototype, h), m && l(b, m), b;
}(e.Component);
a(f, "displayName", "OptionButton"), a(f, "defaultProps", {
  nodeType: "i"
});
export { f as OptionButton };